export class UserTypeModel {
    UserTypeId: number;
    Name: string;
}
export class RolesModel {
    RoleId: number;
    Name: string;
}
export class UserModel {
    UserId: number;
    FirstName: string;
    LastName: string;
    FullName: string;
    UserName: string;
    UserTypeId: number;
    RoleId: number;
    Email: string;
    OrgId: number;
    CreatedBy: number;
    CreatedDate: string;
    StatusTypeId: number;
    UpdatedDate: string;
    UpdatedBy: number;
    CompanyId: number;
    CustomerId: number;
    CompanyName: string;
    LabIds: any;
    PageNo: number;
    PageSize: number;
}

export class UserCred {
    UserId: number;
    UserPwd: string;
    IsSelfPwdUpdate: boolean;
}
export class PageResultDto {
    ClientCode: string;
    PageCount: number;
    PageNo: number;
    PageSize: number;
    TotalRecords: number;
}
